module.controller('image', function(esb, xmppAuth, services, $scope, $mdDialog, dialogLocals, $window, theme, cryptool) {

  var xmpp_domain = cryptool.decryptData($window.sessionStorage.getItem("serviceName"));
  var xmppUser = $window.sessionStorage.getItem('userXmpp');
  $scope.metadataObj = JSON.parse($window.localStorage.getItem("metadataObj"));
  $scope.picFile=dialogLocals.picFile;
  $scope.theme = theme.getTheme();
  var MAX_RETRY = $scope.metadataObj.constraints.max_retry || 2
  
  var currentRetry = parseInt($window.sessionStorage.getItem("uploadRetry") || "0")
 
  $scope.closeDialog = function(){
      $mdDialog.cancel();
  };

  var showAlert = function(message) {
        $mdDialog.show(
            $mdDialog.alert()
                .parent(angular.element(document.querySelector('#popupContainer')))
                .clickOutsideToClose(false)
                .textContent(message)
                .ok('Ok')
                .ariaLabel('Alert Dialog')
        ).then(function() {
            if(document.getElementById("inputSimple"))
                document.getElementById("inputSimple").focus();
        })
};

  $scope.sendMsgImg = function(picFile) {
      $scope.progressCircular = "ok";
      var blobUrl = URL.createObjectURL(picFile);
      var payload = new FormData();
      var format = picFile.type.split("/");
      payload.append("file", picFile);
      payload.append('type', $scope.metadataObj.constraints.imageType  || $scope.data.constraints.type);
      payload.append('latitude', "1");
      payload.append('longitude', "1");
      currentRetry++;
      $window.sessionStorage.setItem("uploadRetry", currentRetry + "");  
      var jqueryParams = {};
      if ($scope.metadataObj.constraints.scoreDocVal && $scope.metadataObj.constraints.scoreDocVal !== null
          && $scope.metadataObj.constraints.typeDocVal && $scope.metadataObj.constraints.typeDocVal !== null 
          && currentRetry < MAX_RETRY){
          jqueryParams.scoreDocVal = $scope.metadataObj.constraints.scoreDocVal;
          jqueryParams.typeDocVal = $scope.metadataObj.constraints.typeDocVal;
      } else {
        jqueryParams.validated = false
      }

      var docValidationMessage =  "No pudimos validar las fotos de tu documento, intenta nuevamente";
      if ($scope.metadataObj.instruction.validationMessage){
          docValidationMessage =  $scope.metadataObj.instruction.validationMessage;
      }

      services.user.userServices('bearer '+$window.localStorage.getItem('access_token1'), jqueryParams).uploadReceipt({}, payload, function(response, event){
          $scope.progressCircular = undefined;

          switch (response.code) {
              case 1:
                  if(response.data.url){
                      var message = {text: response.data.url, url: blobUrl, type: "sent", layout: "end", format: format[1], typeDocument: "Image"}
                      var value =  "{\"code\":\"1\",\"format\":\""+format[1]+"\",\"imageCapture\":\"mandatory\",\"imageType\":\"externalPaymentReceipt\",\"type\":\"Image\",\"url\":\""+esb +"/security"+ response.data.url+"\"}";
                      console.log("message");
                      console.log(message);
                      console.log("value");
                      console.log(value);

                      xmppAuth.Chat.sendMessageImage(xmppUser+"@"+xmpp_domain, "REPLY", $window.sessionStorage.getItem('idAga'), xmpp_domain, message, value);
                      $scope.metadataObj = undefined;
                      $scope.closeDialog();
                  }
                  break;
              case -500:
                  console.log("Document Validator module: internal error server");
                  console.log("Document Validator message: (code:" + response.code + "): " + response.message);
                  var msgInternalError = "Error al subir el archivo, intenta nuevamente";
                  showAlert(msgInternalError);
                  break;
              default:
                  console.log("Document Validator module: internal error server");
                  console.log("Document Validator message: (code:" + response.code + "): " + response.message);
                  var msgInvalidFile = docValidationMessage;
                  if (response.code !== -5)
                      msgInvalidFile += " (" + response.code + ")";
                  showAlert(msgInvalidFile);
                  break;
          }
      });
  };
});
